import {cuppa, log, val} from "../../../../cuppa/cuppa";
import {useEffect, useRef, useState} from "react";

export const InputTextTypes = {NUMBER:'NUMBER', PHONE:'PHONE', MONEY:'MONEY', COMMENT:'COMMENT', EMAIL:'EMAIL', PASSWORD:'PASSWORD', SEARCH:'SEARCH', SEND:'SEND', RICHTEXT:'RICHTEXT', RANGE:'RANGE'}
export function InputText(
	{
		value = '',
		callback = null,
		type = '',
		sign =  '$',
		style = null,
		inputStyle = null,
		className = '',
		onBlur = null,
		id = null,
		initialTrigger = false,
		disabled = false,
		showIcon = true,
		icon = null,
		placeholder = '',
		name = '',
		iconCallback = null,
		maxLength = null,
		showButton = false,
		buttonContent = null,
		buttonStyle = null,
		autoHeight = false,
		min = null,
		max = null,
		rangeLabels = null,
		resizable = false,
		showRevealIcon = false,
		readOnly = false,
		minHeight = 100,
		readOnlyStyles = {backgroundColor:'transparent', border:'none', boxShadow:'none', margin:0},
	}
){
	const [_type, _setType] = useState(type);
	const inputText = useRef();
	
	useEffect(()=>{
		if([InputTextTypes.NUMBER, InputTextTypes.MONEY].indexOf(_type) !== -1){
			new cuppa.inputFilter(inputText.current, '0-9.');
		}else if(_type === InputTextTypes.PHONE){
			new cuppa.inputFilter(inputText.current, '0-9() \+\-');
		}else if(_type === InputTextTypes.RICHTEXT){
			setRichEditor().then()
		}
		if(_type !== InputTextTypes.COMMENT && inputText?.current) cuppa.keyEnter(inputText.current, ()=>{ });
		if(initialTrigger) onChange(value);
	}, []);
	
	useEffect(()=>{
		if(value && inputText?.current?.editor){
			inputText.current.editor.setData(value);
		}
		if(autoHeight){
			setAutoHeight();
		}
	}, [value])
	
	function setAutoHeight(){
		if(!inputText.current) return;
		function calculateHeight(){
			inputText.current.style.minHeight = 0;
			let newMinHeight = inputText?.current?.scrollHeight + 5;
			if(newMinHeight < minHeight) newMinHeight = minHeight;
			inputText.current.style.minHeight = `${newMinHeight}px`;
		}
		inputText.current.style.minHeight = 0;
		inputText.current.style.height = 'auto';
		inputText.current.style.padding = '5px 10px';
		inputText.current.style.overflow = 'hidden';
		calculateHeight();
		inputText.current.oninput = (e)=>{ calculateHeight() }
	}
	
	async function setRichEditor(){
		if(!inputText?.current) return;
		let config = {
			autoGrow: false,
			toolbar: [ 'heading', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
			heading: {
				options: [
					{ model: 'paragraph', title: 'Paragraph', class: 'e-p' },
					{ model: 'heading1', view: 'h1', title: 'Heading 1', class: 'editor-h1' },
					{ model: 'heading2', view: 'h2', title: 'Heading 2', class: 'editor-h2' },
				]
			},
		}
		let richEditor = inputText.current.editor = await window["ClassicEditor"].create(inputText.current, config);
		richEditor.setData(cuppa.htmlEntitiesDecode(value) || '');
		if(readOnly) richEditor.enableReadOnlyMode("my-lock");
		richEditor.model.document.on('change:data', ()=>{
			let text = richEditor.getData();
			onChange(text)
		});
		richEditor.editing.view.document.on('blur', () => {
			let text = richEditor.getData();
			if(onBlur){
				onBlur(text);
			}
		});
	}
	
	function onChange(value){
		if(_type === InputTextTypes.PHONE){
			value = value.replaceAll('.', '');
			value = value.replaceAll(',', '');
		}
		if(callback) callback(value);
	}
	
	value = value || '';
	if(_type === InputTextTypes.RANGE) inputStyle = {...inputStyle, ...{boxShadow:'none', padding:0}};
	if(resizable) inputStyle = {...{resize:'vertical'}, ...inputStyle};
	return(
		<>
			<div className={`flex d-row m-w-9999 ${className} ${disabled ? 'disabled' : null}`} id={id}
			     style={style}>
				{_type === InputTextTypes.MONEY && showIcon && (
					<div className={'button1 button-icon w-auto b-radius-right-0 d-i'}>{sign}</div>
				)}
				{_type === InputTextTypes.PHONE && showIcon && (
					<div className={'button1 button-icon w-auto b-radius-right-0 d-i'}>
						<i className="fa fa-phone fa-rotate-90" aria-hidden="true"></i>
					</div>
				)}
				{_type === InputTextTypes.EMAIL && showIcon && (
					<div className={'button1 button-icon w-auto b-radius-right-0 d-i'}>
						<i className="fas fa-envelope"></i>
					</div>
				)}
				{_type === InputTextTypes.COMMENT ? (
					<textarea
						ref={inputText}
						className={'input1 flex-1'}
						value={value}
						onChange={(e) => {
							onChange(e.target.value)
						}}
						onBlur={(e) => {
							if (onBlur) onBlur(value);
						}}
						style={{...{height: 80, resize: 'none'}, ...inputStyle, ...(readOnly && readOnlyStyles)}}
						disabled={disabled}
						placeholder={placeholder}
						name={name}
						readOnly={readOnly}
					/>
				) : _type === InputTextTypes.RICHTEXT ? (
					<>
						{readOnly ? (
							<div style={{width: '100%', padding:'0 10px'}} dangerouslySetInnerHTML={{__html: cuppa.htmlEntitiesDecode(value)}}></div>
						) : (
							<div ref={inputText} className="rich-editor-target"></div>
						)}
					</>
					
				) : (
					<input
						ref={inputText}
						value={value}
						className={`input1 flex-1 ${[InputTextTypes.MONEY, InputTextTypes.PHONE, InputTextTypes.EMAIL].indexOf(_type) != -1 && showIcon ? `b-radius-left-0` : ''}`}
						onChange={(e) => {
							onChange(e.target.value);
						}}
						onBlur={(e) => {
							if (onBlur) onBlur(value);
						}}
						type={(_type === InputTextTypes.EMAIL) ? 'email' : (_type === InputTextTypes.PASSWORD) ? 'password' : (_type === InputTextTypes.RANGE) ? 'range' : 'text'}
						disabled={disabled}
						style={{...inputStyle, ...(readOnly && readOnlyStyles)}}
						placeholder={placeholder}
						name={name}
						maxLength={(_type === InputTextTypes.PHONE) ? 20 : maxLength}
						min={min}
						max={max}
						readOnly={readOnly}
					/>
				)}
				{_type === InputTextTypes.SEARCH && showIcon && (
					<button
						type={"button"}
						className={'button1 button-icon w-auto b-radius-left-0 '}
						onClick={(e) => {
							if (iconCallback) iconCallback(value);
						}}
					>
						<i className="fa fa-search" aria-hidden="true"></i>
					</button>
				)}
				{_type === InputTextTypes.SEND && showIcon && (
					<button
						type={"button"}
						className={'button1 button-icon w-auto b-radius-left-0 '}
						onClick={(e) => {
							if (iconCallback) iconCallback(value);
						}}
					>
						<i className="fas fa-paper-plane"></i>
					</button>
				)}
				{showRevealIcon && (
					<button
						type={"button"}
						className={'button1 button-icon w-auto b-radius-left-0 '}
						onClick={(e) => {
							e.stopPropagation(); e.preventDefault();
							 _setType(_type === InputTextTypes.PASSWORD ? null : InputTextTypes.PASSWORD);
						}}
					>
						{_type === InputTextTypes.PASSWORD ? <i className="fas fa-eye"></i> : <i className="fas fa-eye-slash"></i>}
						
					</button>
				)}
				{showIcon && cuppa.boolean(icon) && (
					<button
						type={"button"}
						className={'button1 button-icon w-auto b-radius-left-0 '}
						onClick={(e) => {
							if (iconCallback) iconCallback(value);
						}}
					>
						{icon}
					</button>
				)}
				{showButton && (
					<button
						type={"button"}
						className={'button1 button-icon w-auto b-radius-left-0 '}
						style={buttonStyle}
						onClick={(e) => {
							if (iconCallback) iconCallback(value);
						}}
					>
						{buttonContent || null}
					</button>
				)}
			</div>
			{cuppa.boolean(rangeLabels?.length) && (
				<div className={'flex d-row j-between w-100p m-t-20-'}>
					{rangeLabels.map(label=>{
						return <label className={'f-12'} key={label}>{label}</label>
					})}
				</div>
			)}
		</>
	)
}
